import '@progress/kendo-theme-material/dist/all.css';
import 'normalize.css';
import 'index.scss';
import './sentry-instrument';

import { App } from 'App';
import { Auth } from 'auth-provider';
import { createRoot } from 'react-dom/client';
import { Environment } from 'utils/EnvironmentHelper';

import { initPendo } from './init/pendo';
import { init } from './test/server';

initPendo();

Auth.configure({
    // REQUIRED - Amazon Cognito Region
    region: 'us-east-1',
    userPoolId: Environment.cognito.UserPoolId,
    userPoolWebClientId: Environment.cognito.ClientId,
    mandatorySignIn: true,
    oauth: {
        domain: Environment.cognito.Domain,
        scope: ['profile', 'openid'],
        redirectSignIn: `${window.origin}/`,
        redirectSignOut: `${window.origin}/login`,
        responseType: 'code',
    },
});

init().then(() => {
    const container = document.getElementById('root');
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const root = createRoot(container!);
    root.render(<App />);
});
